// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__0up_A","Required":"Label_Required__VjOs4","Autofilled":"Label_Autofilled__2w2EG"};